import { render } from "./Mundos.vue?vue&type=template&id=73e7a162"
import script from "./Mundos.vue?vue&type=script&lang=js"
export * from "./Mundos.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__